import React, { useEffect, useState } from 'react';
// Shared target date so all timers on the page sync up
// We'll set it to 23h 59m 50s from when the module loads
const TARGET_MS = 23 * 60 * 60 * 1000 + 59 * 60 * 1000 + 50 * 1000;
const targetDate = new Date().getTime() + TARGET_MS;
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 50
  });
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;
      if (distance < 0) {
        clearInterval(interval);
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      setTimeLeft({
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex flex-col items-center gap-4" data-id="element-94">
      <div className="flex items-center gap-4 text-white" data-id="element-95">
        <div className="flex flex-col items-center" data-id="element-96">
          <div className="bg-petroleo border border-naranja/50 rounded-lg w-16 h-16 flex items-center justify-center text-3xl font-bold shadow-inner" data-id="element-97">
            {pad(timeLeft.hours)}
          </div>
          <span className="text-xs text-gray-400 mt-2 uppercase tracking-wider" data-id="element-98">
            hs
          </span>
        </div>
        <div className="text-3xl font-bold text-naranja animate-pulse pb-6" data-id="element-99">
          :
        </div>
        <div className="flex flex-col items-center" data-id="element-100">
          <div className="bg-petroleo border border-naranja/50 rounded-lg w-16 h-16 flex items-center justify-center text-3xl font-bold shadow-inner" data-id="element-101">
            {pad(timeLeft.minutes)}
          </div>
          <span className="text-xs text-gray-400 mt-2 uppercase tracking-wider" data-id="element-102">
            min
          </span>
        </div>
        <div className="text-3xl font-bold text-naranja animate-pulse pb-6" data-id="element-103">
          :
        </div>
        <div className="flex flex-col items-center" data-id="element-104">
          <div className="bg-petroleo border border-naranja/50 rounded-lg w-16 h-16 flex items-center justify-center text-3xl font-bold shadow-inner" data-id="element-105">
            {pad(timeLeft.seconds)}
          </div>
          <span className="text-xs text-gray-400 mt-2 uppercase tracking-wider" data-id="element-106">
            seg
          </span>
        </div>
      </div>
    </div>;
}